export default __webpack_public_path__ + "static/media/Targets.6b9ba113.svg";